function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#bbb;}.cls-3{fill:#ff7f40;}.cls-4{fill:#e64b38;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M569.56,264.18v38.6H519.82a145.75,145.75,0,0,0,0,186.44h51v39.16a146,146,0,0,0,123.47-.56V427.48H570.8V365.75H694.27V264.18a146.05,146.05,0,0,0-124.71,0Z",
  transform: "translate(-468 -232.09)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M631.92,250.2a145.11,145.11,0,0,1,62.35,14V245h1.56a164.14,164.14,0,0,0-126.27-.64v19.78A145.3,145.3,0,0,1,631.92,250.2Z",
  transform: "translate(-468 -232.09)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M519.82,489.22a145.75,145.75,0,0,1,0-186.44h-12V289a163.76,163.76,0,0,0,1.23,215.5V489.22Z",
  transform: "translate(-468 -232.09)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M631.92,541.8a145.24,145.24,0,0,1-61.12-13.42v19.71a164,164,0,0,0,123.47-.49V527.82A145.11,145.11,0,0,1,631.92,541.8Z",
  transform: "translate(-468 -232.09)"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "51.82 70.7 101.56 70.7 101.56 32.1 101.56 12.31 101.56 11.72 39.83 11.72 39.83 56.88 39.83 70.7 51.82 70.7"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-4",
  points: "227.83 12.95 226.27 12.95 226.27 32.09 226.27 133.66 102.8 133.66 102.8 195.4 226.27 195.4 226.27 295.74 226.27 315.52 226.27 316.11 288 316.11 288 12.95 227.83 12.95"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "102.8 257.13 51.82 257.13 41.06 257.13 41.06 272.38 41.06 316.11 102.8 316.11 102.8 316 102.8 296.29 102.8 257.13"
});

var SvgChLogo = function SvgChLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 288 327.83",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHLogo.453ca306.svg";
export { ForwardRef as ReactComponent };